/* PTB Atelier — aperçu indicatif de la broderie (silhouettes SVG, texte ou image, couleur du fil).
   L'aperçu ne remplace pas le rendu brodé réel : il sert uniquement à situer le motif. */
(function () {
  'use strict';
  var C = window.PTB_ATELIER_CFG;
  if (!C) return;
  var A = (window.PTBAtelier = window.PTBAtelier || {});

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hexToRgb(h) {
    h = String(h || '#888').replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h, 16);
    return isNaN(n) ? [136, 136, 136] : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function lum(h) { var c = hexToRgb(h); return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }
  function mix(h, to, k) {
    var a = hexToRgb(h), b = hexToRgb(to);
    return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(a[i] * (1 - k) + b[i] * k); }).join(',') + ')';
  }

  /* ---------- silhouettes (viewBox 0 0 400 440) ---------- */
  var TEE = 'M135 42C150 36 165 34 175 33C185 52 215 52 225 33C235 34 250 36 265 42L338 78L362 128L316 150L292 118L292 400L108 400L108 118L84 150L38 128L62 78Z';
  var TEE_BACK = 'M135 42C150 36 165 34 175 33C185 41 215 41 225 33C235 34 250 36 265 42L338 78L362 128L316 150L292 118L292 400L108 400L108 118L84 150L38 128L62 78Z';
  var POLO = 'M135 42C150 36 165 34 178 33L200 80L222 33C235 34 250 36 265 42L338 78L362 128L316 150L292 118L292 400L108 400L108 118L84 150L38 128L62 78Z';
  var HOODIE = 'M128 70C150 52 175 46 200 52C225 46 250 52 272 70L342 112L374 330L324 346L296 190L292 404L108 404L104 190L76 346L26 330L58 112Z';
  var HOOD = 'M148 64C146 12 254 12 252 64C240 104 160 104 148 64Z';
  var CAP_DOME = 'M62 232C62 112 130 72 200 72C270 72 338 112 338 232Z';
  var CAP_VISOR = 'M46 234C120 280 280 280 354 234L362 250C282 320 118 320 38 250Z';
  var BEANIE_DOME = 'M104 272C104 112 150 68 200 68C250 68 296 112 296 272Z';
  var BAG = 'M60 190C60 130 140 100 200 100C260 100 340 130 340 190L320 340C300 362 100 362 80 340Z';

  function silhouette(opts) {
    var sub = opts.sub, cat = opts.cat, back = opts.placement === 'back';
    var fill = opts.garment || '#1a1a1a';
    var dark = lum(fill) < 0.55;
    var stroke = dark ? 'rgba(245,241,232,.38)' : 'rgba(0,0,0,.32)';
    var shade = 'url(#atl-shade)';
    var s = '';
    function shape(d, extra) { return '<path d="' + d + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="2" stroke-linejoin="round" ' + (extra || '') + '/><path d="' + d + '" fill="' + shade + '" opacity=".55" stroke="none"/>'; }
    if (sub === 'top') {
      if (cat === 'sweat') {
        s += shape(HOODIE);
        if (!back) {
          s += '<path d="' + HOOD + '" fill="' + mix(fill, dark ? '#000000' : '#000000', 0.18) + '" stroke="' + stroke + '" stroke-width="2"/>';
          s += '<path d="M138 304L262 304L278 366L122 366Z" fill="none" stroke="' + stroke + '" stroke-width="1.6" stroke-dasharray="4 4"/>';
          s += '<path d="M188 70L186 128M212 70L214 128" stroke="' + stroke + '" stroke-width="2" fill="none"/>';
        } else {
          s += '<path d="' + HOOD + '" fill="' + mix(fill, '#000000', 0.12) + '" stroke="' + stroke + '" stroke-width="2"/>';
        }
      } else if (cat === 'polo') {
        s += shape(back ? TEE_BACK : POLO);
        if (!back) {
          s += '<path d="M178 33L150 50L172 82L200 80Z M222 33L250 50L228 82L200 80Z" fill="' + mix(fill, '#000000', 0.16) + '" stroke="' + stroke + '" stroke-width="1.6"/>';
          s += '<path d="M200 80L200 150" stroke="' + stroke + '" stroke-width="2"/><circle cx="200" cy="100" r="3" fill="' + stroke + '"/><circle cx="200" cy="124" r="3" fill="' + stroke + '"/>';
        }
      } else {
        s += shape(back ? TEE_BACK : TEE);
      }
    } else if (sub === 'cap') {
      s += shape(CAP_DOME);
      if (!back) s += shape(CAP_VISOR);
      s += '<path d="M200 74L200 232M132 92C150 150 150 200 150 232M268 92C250 150 250 200 250 232" stroke="' + stroke + '" stroke-width="1.4" fill="none" opacity=".7"/><circle cx="200" cy="74" r="7" fill="' + mix(fill, dark ? '#ffffff' : '#000000', 0.2) + '" stroke="' + stroke + '"/>';
      if (back) s += '<rect x="140" y="206" width="120" height="26" rx="6" fill="' + mix(fill, '#000000', 0.15) + '" stroke="' + stroke + '"/>';
    } else if (sub === 'beanie') {
      s += shape(BEANIE_DOME);
      s += '<rect x="90" y="262" width="220" height="80" rx="14" fill="' + mix(fill, '#000000', 0.1) + '" stroke="' + stroke + '" stroke-width="2"/>';
      var ribs = ''; for (var x = 112; x < 300; x += 16) ribs += 'M' + x + ' 266L' + x + ' 338';
      s += '<path d="' + ribs + '" stroke="' + stroke + '" stroke-width="1" opacity=".5" fill="none"/>';
    } else if (sub === 'bag') {
      s += '<path d="M118 122C104 70 84 44 70 22" stroke="' + stroke + '" stroke-width="10" fill="none" stroke-linecap="round" opacity=".9"/>';
      s += shape(BAG);
      s += '<path d="M72 172C140 150 260 150 330 172" stroke="' + stroke + '" stroke-width="2" fill="none"/>';
    } else {
      s += shape('M90 90L310 90Q330 90 330 110L330 350Q330 370 310 370L90 370Q70 370 70 350L70 110Q70 90 90 90Z');
    }
    return s;
  }

  /* zones brodables (centre + taille max) par silhouette et emplacement, dans le viewBox */
  function anchor(opts) {
    var sub = opts.sub, cat = opts.cat, p = opts.placement;
    if (sub === 'top') {
      var longSleeve = cat === 'sweat';
      var map = {
        chest_left: { x: 252, y: 130, w: 68, h: 46 }, chest_right: { x: 148, y: 130, w: 68, h: 46 }, chest_center: { x: 200, y: 176, w: 150, h: 100 },
        back: { x: 200, y: 176, w: 170, h: 160 },
        sleeve_left: longSleeve ? { x: 350, y: 236, w: 42, h: 60, r: 8 } : { x: 334, y: 112, w: 44, h: 30, r: 30 },
        sleeve_right: longSleeve ? { x: 50, y: 236, w: 42, h: 60, r: -8 } : { x: 66, y: 112, w: 44, h: 30, r: -30 },
        custom: { x: 200, y: 200, w: 140, h: 100 }
      };
      return map[p] || map.chest_center;
    }
    if (sub === 'cap') {
      return ({ front: { x: 200, y: 160, w: 128, h: 58 }, side_left: { x: 306, y: 170, w: 54, h: 44, r: 12 }, side_right: { x: 94, y: 170, w: 54, h: 44, r: -12 }, back: { x: 200, y: 160, w: 120, h: 40 }, custom: { x: 200, y: 160, w: 128, h: 58 } })[p] || { x: 200, y: 160, w: 128, h: 58 };
    }
    if (sub === 'beanie') return { x: 200, y: 302, w: 140, h: 48 };
    if (sub === 'bag') return { x: 200, y: 250, w: 160, h: 84 };
    return { x: 200, y: 230, w: 170, h: 120 };
  }

  A.preview = {};

  A.preview.fontsLoaded = {};
  A.preview.loadFont = function (font) {
    if (!font || !font.google || A.preview.fontsLoaded[font.id]) return Promise.resolve();
    A.preview.fontsLoaded[font.id] = true;
    try {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=' + font.google + '&display=swap';
      document.head.appendChild(link);
      if (document.fonts && document.fonts.load) return document.fonts.load('32px "' + font.family + '"', 'Aaابⴰ').catch(function () {});
    } catch (e) { /* hors ligne : la police de secours sera utilisée */ }
    return Promise.resolve();
  };

  /* charge plusieurs polices en une seule feuille de style (une requête) */
  A.preview.loadFonts = function (fonts) {
    var todo = (fonts || []).filter(function (f) { return f && f.google && !A.preview.fontsLoaded[f.id]; });
    if (!todo.length) return Promise.resolve();
    todo.forEach(function (f) { A.preview.fontsLoaded[f.id] = true; });
    try {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' + todo.map(function (f) { return 'family=' + f.google; }).join('&') + '&display=swap';
      document.head.appendChild(link);
      if (document.fonts && document.fonts.load) {
        return Promise.all(todo.map(function (f) { return document.fonts.load('32px "' + f.family + '"', 'Aaابⴰ').catch(function () {}); }));
      }
    } catch (e) { /* hors ligne : la police de secours sera utilisée */ }
    return Promise.resolve();
  };

  /* opts : sub, cat, placement, garment(hex), type('text'|'image'|null), text, font{family}, thread(hex), outline(hex), image(dataURL), emptyLabel, caption */
  A.preview.html = function (opts) {
    var a = anchor(opts);
    var thread = opts.thread || '#f5f1e8';
    var out = '<svg class="atl-svg" viewBox="0 0 400 440" role="img" aria-label="' + esc(opts.aria || '') + '" xmlns="http://www.w3.org/2000/svg">';
    out += '<defs><linearGradient id="atl-shade" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".18"/><stop offset=".5" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".28"/></linearGradient>';
    out += '<filter id="atl-emb" x="-5%" y="-5%" width="110%" height="120%"><feDropShadow dx="0" dy=".9" stdDeviation=".5" flood-color="#000" flood-opacity=".55"/></filter></defs>';
    out += silhouette(opts);
    var tr = a.r ? ' transform="rotate(' + a.r + ' ' + a.x + ' ' + a.y + ')"' : '';
    out += '<g' + tr + '>';
    out += '<rect x="' + (a.x - a.w / 2) + '" y="' + (a.y - a.h / 2) + '" width="' + a.w + '" height="' + a.h + '" rx="4" fill="none" stroke="' + (lum(opts.garment || '#1a1a1a') < 0.55 ? 'rgba(245,241,232,.45)' : 'rgba(0,0,0,.4)') + '" stroke-width="1" stroke-dasharray="3 3"/>';
    if (opts.type === 'image' && opts.image) {
      out += '<image href="' + esc(opts.image) + '" x="' + (a.x - a.w / 2) + '" y="' + (a.y - a.h / 2) + '" width="' + a.w + '" height="' + a.h + '" preserveAspectRatio="xMidYMid meet"/>';
    } else if (opts.type === 'text') {
      var txt = (opts.text || '').trim();
      var fam = (opts.font && opts.font.family) ? opts.font.family : 'Anton';
      out += '<text class="atl-svgtext" x="' + a.x + '" y="' + a.y + '" text-anchor="middle" dominant-baseline="central" font-family="\'' + esc(fam) + '\', Anton, Arial, sans-serif" font-size="40"' +
        ' fill="' + (txt ? esc(thread) : (lum(opts.garment || '#1a1a1a') < 0.55 ? 'rgba(245,241,232,.45)' : 'rgba(26,23,20,.4)')) + '" stroke="' + (txt ? (opts.outline ? esc(opts.outline) : mix(thread, '#000000', 0.45)) : 'none') + '" stroke-width="' + (opts.outline ? '1.6' : '.6') + '" paint-order="stroke" filter="url(#atl-emb)"' +
        ' data-w="' + a.w + '" data-h="' + a.h + '">' + esc(txt || (opts.emptyLabel || '')) + '</text>';
    }
    out += '</g></svg>';
    return out;
  };

  /* ajuste la taille du texte à la zone, une fois l'SVG inséré dans le DOM */
  A.preview.fit = function (el) {
    var t = el && el.querySelector('text.atl-svgtext');
    if (!t || !t.getBBox) return;
    try {
      t.setAttribute('font-size', '40');
      var bb = t.getBBox();
      if (!bb.width || !bb.height) return;
      var w = parseFloat(t.getAttribute('data-w')), h = parseFloat(t.getAttribute('data-h'));
      var k = Math.min(w / bb.width, h / bb.height, 2.2);
      t.setAttribute('font-size', String(Math.max(6, 40 * k)));
    } catch (e) { /* élément non rendu */ }
  };

  A.preview.render = function (el, opts) {
    if (!el) return;
    el.innerHTML = A.preview.html(opts);
    A.preview.fit(el);
    if (opts.type === 'text' && opts.font) {
      A.preview.loadFont(opts.font).then(function () { A.preview.fit(el); });
    }
  };
})();
